import * as pdfjsLib from 'pdfjs-dist';
import packageJson from '../../package.json';

const version = packageJson.version;
pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://static.workforcenow.adp.com/mas/mdf-components/' + version + '/pdfjsdist/pdf.worker.min.js';

export interface PdfValidationResult {
  isValid: boolean;
  numPages?: number;
  error?: string;
}

export class PdfValidator {
  static async validateDocument(pdfBlob: Blob | MediaSource): Promise<PdfValidationResult> {
    let url = '';
    try {
      url = URL.createObjectURL(pdfBlob);

      const pdf = await pdfjsLib.getDocument(url).promise;
      URL.revokeObjectURL(url);

      return {
        isValid: true,
        numPages: pdf.numPages
      };
    }
    catch (error) {
      if (url) {
        URL.revokeObjectURL(url);
      }

      return {
        isValid: false,
        error: 'Error processing PDF file!'
      };
    }
  }
}
